export const StudentMasterEndpoint = {
  student: "student",
  studentList: "student/filter",
  studentListView: "student/view",
  assessmentScoreController: "student/assessment/score",
  promoCode: "promo_code",
  course: "course",
  ci_name: "ci/dropdown",
  batch_name: "batch/dropdown",
  journey: "student/journey",
  level_name: "courseLevel",
  level_discontinue_confirmation: "level_discontinue_confirmation",
  levelStatusChangeDiscontinue: "levelStatusChangeDetails/discontinue",
  levelStatusChangeActive: "levelStatusChangeDetails/active",
  export: "student/export/excel",
  batchTransfer: "student/batchTransfer",
  studentDropdown: "student/dropdown",
  sendLink: "generate-parent-link",
  exportPdf: "student/studentDetail/",
  studentListCourseLevelWise: "student/studentListCourseLevelWise/",
  sentOtp: "student/sentOtp",
  verifyOtp: "student/verifyOtp",
  isExistsMobileNo: "student/isExistsMoreThanThrice",
};
